<script setup lang="ts">
import { RouterView } from 'vue-router'
import { useChatStore } from '@/stores/chat'
import { useSessionStore } from '@/stores/session'
import { useSecurityPromptStore } from '@/stores/securityPrompt'
import { onMounted } from 'vue'
import MerMemberFloatingBar from '@/components/MerMemberFloatingBar.vue'
import SecurityPromptHost from '@/components/security/SecurityPromptHost.vue'
import BroadcastPopup from '@/components/BroadcastPopup.vue'
import { useBroadcastStore } from '@/stores/broadcast'
import { useNotifyStore } from './stores/notify'
import OrderNotifyOverlay from '@/components/OrderNotifyOverlay.vue'
import LuckyWheelChanceModalHost from '@/components/raffle/LuckyWheelChanceModalHost.vue'

const broadcastStore = useBroadcastStore()

const chatStore = useChatStore()
const sessionStore = useSessionStore()
const securityPromptStore = useSecurityPromptStore()

const notifyStore = useNotifyStore()

function handleCloseNotification(msgId: number) {
  notifyStore.removeOrderNotification(msgId)
}

async function handleIgnoreNotification(msgId: number) {
  try {
    await notifyStore.acknowledgeNotification([msgId])
  } catch (error) {
    console.error('标记通知已读失败:', error)
  }
}

onMounted(async () => {
  chatStore.connectWebSocket()
  if (sessionStore.sessionId) {
    await securityPromptStore.checkAndEnqueue()
    await broadcastStore.fetchAndShow()
    notifyStore.syncNotifications()
  }
})
</script>

<template>
  <RouterView />
  <MerMemberFloatingBar />
  <SecurityPromptHost />
  <BroadcastPopup />
  <OrderNotifyOverlay
    v-for="(notification, index) in notifyStore.orderNotifyQueue"
    :key="notification.msg_id"
    :data="notification"
    :top-offset="60 + index * 60"
  />
  <LuckyWheelChanceModalHost />
</template>

<style scoped></style>
